<template>
  <div>
    <SeoHead />
    <slot />
  </div>
</template>

<style lang="postcss">
@tailwind base;
@tailwind components;
@tailwind utilities;
</style>

<script>
import SeoHead from '@/lego/layouts/SeoHead.vue';

export default {
  components: {
    SeoHead,
  },
};
</script>
